import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import initialiser from '../../utils/initialiser';

import App from './containers/App';
import Modal from './components/Modal';
import { store } from './store';

class CreateYourOwnPackage {
  readonly container: HTMLElement;

  static instance: CreateYourOwnPackage;

  constructor({ el }) {
    this.container = el;
    CreateYourOwnPackage.instance = this;

    // Expose the showModal function to the window
    if (typeof window !== 'undefined') {
      window.createYourOwnPackage = window.createYourOwnPackage || {};
      window.createYourOwnPackage.showModal = this.showModal;
    }
  }

  init = () => {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <App node={this.container} />
        </Provider>
      </React.StrictMode>,
      this.container,
    );
  };

  showModal = (modalProps: any) => {
    const modalElement = document.createElement('div');
    modalElement.id = 'timer-expired-modal-container';
    document.body.appendChild(modalElement);

    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <Modal
            {...modalProps}
            setModal={() => {
              ReactDOM.unmountComponentAtNode(modalElement);
              document.body.removeChild(modalElement);
              document.body.classList.remove('has-modal-opened');
            }}
          />
        </Provider>
      </React.StrictMode>,
      modalElement,
    );

    document.body.classList.add('has-modal-opened');
  };
}

// Add type definition for the window object
declare global {
  interface Window {
    createYourOwnPackage?: {
      showModal?: (modalProps: any) => void;
    };
  }
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, CreateYourOwnPackage);
